// src/pages/About.jsx
import React from "react";
import "./About.css";

// NEW: SEO
import SEO from "../components/SEO";

export default function About() {
  return (
    <div className="main-content about-us">
      {/* SEO: unique meta for About page */}
      <SEO
        title="About Talkvee - Safer Random Video Chat with VeeClips Coming Soon"
        description="Talkvee is a safer alternative to Ome.tv and Monkey app. Play trivia, match by interests, and soon share VeeClips. Built for fun, safe conversations."
        pathname="/about"
      />

      <h1>About Talkvee</h1>

      <div
        className="about-us-content"
        style={{ display: "flex", gap: "20px", alignItems: "flex-start" }}
      >
        <div className="about-us-image">
          <img
            src={"/about us.png"}
            alt="Talkvee connections"
            style={{
              width: "300px",
              height: "auto",
              display: "block",
              margin: "0 auto 15px auto",
            }}
          />
        </div>

        <div className="about-us-text">
          <h2>More than random video chat</h2>
          <p>
            Talkvee isn’t just another “click and skip” chat site. We’re building
            a social space where conversations actually have something fun to
            spark them. Yes, you can video or text chat with new people worldwide
            — but that’s only the beginning.
          </p>

          <h3>What makes Talkvee different?</h3>
          <ul>
            <li>
              🎮 <strong>Play Together</strong> — Jump into quick mini-games like trivia
              challenges, tic-toc-toe, 4 in row or 4 connect, and more. Win, laugh,
              and connect while doing something fun.
            </li>
            <li>
              🔍 <strong>Shared Interests</strong> — Match with people who like the same
              topics as you, instead of just random strangers.
            </li>
            <li>
              🎥 <strong>VeeClips</strong> — A new way to capture and share
              your Talkvee moments. Whether it’s a fun challenge, a surprising quiz win,
              or just a good laugh, VeeClips lets users 
              share short highlights — like reels or shorts — with the community.
            </li>
            <li>
              🛡 <strong>Safe & Friendly</strong> — With community guidelines, quick
              reporting, and ad-free design, Talkvee feels more like a hangout
              than a gamble.
            </li>
            <li>
              ⚡ <strong>Fast & Easy</strong> — Join as a guest in seconds or install our
              PWA for a smooth app-like experience.
            </li>
          </ul>

          {/* NEW COMPETITOR COMPARISON SECTION FOR SEO */}
          <h3>Talkvee vs. Other Chat Apps</h3>
          <p>
            We know you have choices when it comes to meeting strangers online. 
            Many users come to us looking for a <strong>better alternative to Ome.tv</strong> or 
            apps like <strong>Monkey</strong> and <strong>Azar</strong>. Here is why Talkvee stands out:
          </p>
          <ul>
            <li>
              <strong>Better than Ome.tv & Minichat:</strong> Talkvee is 100% ad-free. 
              We don't interrupt your chats with annoying pop-ups, and our design is cleaner and more modern.
            </li>
            <li>
              <strong>Safer than Monkey App:</strong> We prioritize safety with strict moderation 
              and community guidelines to prevent the toxic behavior often found on other platforms.
            </li>
            <li>
              <strong>More fun than Azar:</strong> We don't just connect you; we give you 
              things to do. With built-in games like <em>Trivia</em> and <em>Tic-Tac-Toe</em>, 
              awkward silences are a thing of the past.
            </li>
          </ul>

          <h3>Who we are</h3>
          <p>
            Talkvee was created by a small group of students who wanted a better,
            safer, and more positive way to meet people online. We didn’t like how
            many chat sites felt unsafe, corporate, or crammed with ads — so we built
            something different.
          </p>
          <p>
            We are independent and not connected to any organization or company.
            Talkvee is community-driven, designed to be simple, welcoming, and fun —
            a place where you can actually enjoy conversations without the noise.
          </p>
          <p>
            Our goal is simple: keep Talkvee free, safe, and enjoyable — a space
            built for people, not profits.
          </p>

          <h3>Privacy & Safety</h3>
          <ul>
            <li><strong>No ads</strong> distracting you or following you around.</li>
            <li><strong>Data respect</strong> — your conversations aren’t harvested for advertising.</li>
            <li><strong>Controls that work</strong> — easy reporting and clear community guidelines.</li>
            <li><strong>Friendly by design</strong> — tools that encourage good vibes and discourage abuse.</li>
          </ul>

          <h3>Our vision</h3>
          <p>
            We want Talkvee to feel like a playground for meeting people —
            conversations that start with a game, an idea, or just curiosity.
            Less awkward skipping, more real moments.
          </p>

          <p style={{ marginTop: 12 }}>
            Ready to try? Hit <em>Find Partner</em> and see where the next chat (or
            game) takes you.
          </p>
        </div>
      </div>
    </div>
  );
}